var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJointStiffness(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2241",
    xmlSpace: "preserve",
    width: 682.66669,
    height: 682.66669,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2245"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2255"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path2253"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2247",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2249"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2251",
    clipPath: "url(#clipPath2255)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2257",
    transform: "translate(324.2847,288.2949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 10.114,-7.163 16.715,-18.958 16.715,-32.295 0,-13.18 -6.447,-24.854 -16.36,-32.041",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2259"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2261",
    transform: "translate(187.6426,223.7568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -10.073,7.168 -16.643,18.938 -16.643,32.243 0,13.463 6.727,25.355 17.003,32.497",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2263"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2265",
    transform: "translate(296.0005,57.3242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 0.002,-47.324 H -80.003 V 89.609 c -23.342,2.152 -41.464,22.322 -40.331,46.474 1.077,22.971 19.838,41.517 42.819,42.348 11.08,0.4 21.298,-3.25 29.289,-9.586 4.801,-3.807 11.65,-3.807 16.451,0 7.991,6.336 18.209,9.986 29.289,9.586 C 20.495,177.6 39.256,159.054 40.333,136.083 41.466,111.931 23.344,91.761 0.002,89.609",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2267"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2269",
    transform: "translate(296.0005,102.5967)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 0",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2271"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2273",
    transform: "translate(215.9976,146.9336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 26.002",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2275"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2277",
    transform: "translate(175.666,318.5928)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 1.077,-22.971 19.839,-41.517 42.82,-42.348 11.08,-0.4 21.298,3.25 29.289,9.586 4.8,3.807 11.65,3.807 16.45,0 7.991,-6.336 18.209,-9.986 29.289,-9.586 22.981,0.831 41.743,19.377 42.82,42.348 1.133,24.152 -16.99,44.322 -40.332,46.474 V 183.407 H 40.332 V 46.474 C 16.99,44.322 -1.133,24.152 0,0 Z",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2279"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2281",
    transform: "translate(269.9985,364.999)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 26.002",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2283"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2285",
    transform: "translate(420.8437,256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -18.596",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2287"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2289",
    transform: "translate(395.2939,194.3174)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -13.149,13.149",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2291"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2293",
    transform: "translate(382.1445,304.5332)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 13.149,13.149",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2295"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2297",
    transform: "translate(91.1563,256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H 18.596",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2299"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2301",
    transform: "translate(116.7061,317.6826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 13.149,-13.149",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2303"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2305",
    transform: "translate(129.8555,207.4668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -13.149,-13.149",
    style: {
      fill: "none",
      stroke: "currentColor",
      strokeWidth: 20,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    id: "path2307"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJointStiffness);
export default __webpack_public_path__ + "static/media/joint-stiffness.a71748d6d15f6cf18eab54b664e7e0a9.svg";
export { ForwardRef as ReactComponent };